import { RedirectContainer } from '../organisms'

export const RedirectPage = () => {
  return (
    <RedirectContainer />
  )
}
